import React, { useEffect , useState } from 'react';

import {
  Card,
  CardHeader ,
  CardBody, 
  CardTitle, 
  CardText, 
  CardSubtitle, 
  Button,
  Container,
  Row,
  Col,
  Input,
  Label,
  Form,
  FormGroup
} from 'reactstrap';

import axios from 'axios';
import { useForm } from "react-hook-form"

import { SubmitButton , FormInput } from '../../components/MyForm'
import ContentWrapper from  '../../components/Layout/ContentWrapper'
import { contact_us_endpoint } from "../../libs/endpoints";

const ContactUsForm = ({next_view}) => {

  const {
    register,
    handleSubmit,
    reset,
    setError,
    clearErrors,
    formState: { errors }
  } = useForm();

  const [rego_data , set_rego_data] = useState({
      first_name: '',
      last_name : '',
      email: '',
      subject : '',
      message : ''
  })

  const [count_chars , set_count_chars] = useState(0)

  useEffect(() => {
  },[]);


  return (
    <>

<div>
  
  <p>
    We collect the following information when you contact us. We answer most queries within 24–48 hours.
   </p>

</div>

    
    <Form onSubmit={handleSubmit(async (data) => { 
        try {
             console.log(data)
             const response = await axios.post(`${contact_us_endpoint}`, data);
             console.log('has been submitted')
             reset();
             next_view()
        } catch (error) {
            console.log(error)
        }
    })}>


    <Card>
     <CardBody>


   <FormGroup>
       <FormInput
        register={register}
        name='first_name'
        id='first_name'
        label='First Name'
        type='text'
        validation={{
            required: 'First name is empty!',
            pattern: {
                value: /^[A-Za-z]+$/i,
                message: "Only letters are allowed"
            },
            maxLength: {
                value: 20,
                message: "Maximum length is 20 characters"
            }
        }}
        invalid={errors.first_name}
        defaultValue={rego_data.first_name}
       />

      {errors.first_name && (<div>{errors.first_name.message}</div>)}

    </FormGroup>


     <FormGroup>
       <FormInput
        register={register}
        name='last_name'
        id='last_name'
        label='Last Name'
        type='text'
        validation={{
            required: 'Last name is empty!',
            pattern: {
                value: /^[A-Za-z]+$/i,
                message: "Only letters are allowed"
            },
            maxLength: {
                value: 20,
                message: "Maximum length is 20 characters"
            }
        }}
        invalid={errors.last_name}
        defaultValue={rego_data.last_name}
       />

      {errors.last_name && (<div>{errors.last_name.message}</div>)}

    </FormGroup>


    <FormGroup>
       <FormInput
        register={register}
        name='email'
        id='email'
        label='Email'
        type='text'
        validation={{
            required: 'Email is empty!',
            pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: "Invalid email",
            },
        }}
        invalid={errors.email}
        defaultValue={rego_data.email}
       />

      {errors.email && (<div>{errors.email.message}</div>)}

    </FormGroup>

    <FormGroup>
       <FormInput
        register={register}
        name='subject'
        id='subject'
        label='Subject'
        type='text'
        validation={{
            required: 'Subject is empty!',
            maxLength: {
                value: 100,
                message: "Maximum length is 100 characters"
            }
        }}
        invalid={errors.subject}
        defaultValue={rego_data.subject}
       />

      {errors.subject && (<div>{errors.subject.message}</div>)}

    </FormGroup>

   <FormGroup>
      
       <FormInput
        register={register}
        name='message'
        id='message'
        label='Message'
        type="textarea"
        style={{ height: 250 }}
        validation={{
            required: 'Message is empty!',
            maxLength: {
                value: 500,
                message: "Maximum length is 500 characters"
            }
        }}
        invalid={errors.message}
        defaultValue={rego_data.message}
       

         onChange={(e) => {
           // Must call the library's onChange first to update internal state
           register("message").onChange(e);

           if(e.target.value.length <= 500) {
              set_count_chars(e.target.value.length)
              clearErrors('message')
            } else {
                setError('message',  { 
                  'type': 'manual', 
                  'message': 'maximum length is 500 characters'
                })
            }

           // console.log("Input changed!", e.target.value);
        }}

       />

      <h6>{count_chars}/500 characters</h6>
      {errors.message && (<div>{errors.message.message}</div>)}

    </FormGroup>

    </CardBody>

    <CardBody className="border-top gap-2 d-flex align-items-center">
        <Button color="primary">Submit</Button>
    </CardBody>

    </Card>

    </Form>

    </>
  )
}

export default ContactUsForm;
